import ArticleReader from "./ArticleReader";

export default function StandAloneReader() {
  return <ArticleReader />;
}
